import styled from 'styled-components';

export const StyledConfirmationPage = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  height:100%
`;
